import Offline from './Offline'
import Api from '../core/Api'
import localforage from 'localforage'

class Detenteur {

    constructor() {

        this.data = {}

    }

    static serialize(data) {

        let det = Object.assign({}, data);
        det.raisonSociale = det.raison_sociale;
        det.codePostal = det.code_postal;
        det.codeClient = det.code_client;
        det.complementAdresse = det.complement_adresse;
        delete det.complement_adresse;
        delete det.code_client;
        delete det.raison_sociale;
        delete det.code_postal;
        delete det.installations;
        delete det.created_at;
        delete det.updated_at;
        delete det.id;

        return det

    }

    static addDetenteurOffline(data) {
        return new Promise((resolve, reject) => {
            let tempId = 'N-' + +new Date();

            this
                .getList()
                .then(list => {

                    data.id = tempId;
                    list.push(data);

                    localforage
                        .setItem('listDetenteurs', JSON.stringify(list))
                        .then(() => {

                            return Offline.saveAction({
                                action: 'add',
                                type: 'Detenteur',
                                id: tempId
                            })

                        })
                        .then(() => {

                            resolve('Ajout offline ok')

                        })
                        .catch(err => reject(err))
                })
        })
    }

    static getDetenteurOnline(id) {
        return new Promise((resolve, reject) => {
            Api.init()
                .then(api => {
                    return api.get('/detenteur/' + id);
                })
                .then(result => {
                    if (!_.isEmpty(result.data) && result.data[0] !== undefined) {
                        resolve(result.data[0]);
                    } else {
                        reject(new Error("Aucun détenteur trouvé pour l'identifiant " + id));
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    static addDetenteurOnline(data) {
        return new Promise((resolve, reject) => {
            Api
                .init()
                .then(api => {

                    api
                        .post('/detenteur', data)
                        .then(result => {

                            if (!result.data.hasOwnProperty('errors')) {
                                resolve(result.data)
                            } else {
                                let errs = {
                                    apiMsg: result.data.errors,
                                    payload: data
                                };
                                reject(errs)
                            }

                        })
                        .catch(err => {
                            reject(err)
                        })

                })
                .catch(err => reject(err))
        })
    }

    static async updateDetenteur(data) {
        let dets = await Detenteur.getList();
        let id;

        if (!_.includes(data.id, 'N-')) {
            id = parseInt(data.id)
        } else {
            id = data.id
        }

        let index = _.findIndex(dets, ['id', id]);
        dets[index] = data;

        await localforage.setItem('listDetenteurs', JSON.stringify(dets));

        await Offline.saveAction({
            type: 'Detenteur',
            action: 'update',
            id: id
        });

        return true;
    }

    static async updateDeteneteurOnline(id){
        return new Promise((resolve, reject) => {
            Detenteur
                .getDetenteur(id)
                .then(res => {
                    let payload = Detenteur.serialize(res);

                    Api
                        .init()
                        .then(api => {
                            api
                                .patch('/detenteur/'+id, payload)
                                .then(res => {

                                    if (!res.data.hasOwnProperty('errors')) {
                                        resolve(res.data)
                                    } else {
                                        reject(res.data.errors)
                                    }

                                })
                                .catch(err => reject(err))
                        })
                        .catch(err => reject(err))
                })
                .catch(err => reject(err))
        })
    }

    static getDetenteur(id) {
        return new Promise((resolve, reject) => {
            this.getList().then( res => {

                if (!_.includes(id, 'N-')) {
                    id = parseInt(id)
                }

                const det = _.find(res, ['id', id]);

                if (det !== undefined) {
                    resolve(det);
                } else {
                    this.getDetenteurOnline(id)
                        .then(onlineDet => resolve(onlineDet))
                        .catch(err => reject(err));
                }

            }).catch(err => reject(err))

        })

    }

    static searchByDetenteur(data) {
        return new Promise((resolve, reject) => {
            this.getList().then(res => {
                // Si data est un ID (string ou number), on le transforme en objet { id: ... }
                if (typeof data === 'string' || typeof data === 'number') {
                    const id = !String(data).includes('N-') ? parseInt(data) : data;
                    data = { id: id };
                }

                // Recherche dans la liste locale
                const det = _.find(res, data);

                if (det !== undefined) {
                    resolve(det);
                } else {
                    // Si aucun résultat local, on tente une recherche en ligne si un ID est présent
                    const id = data.id;
                    if (id !== undefined) {
                        resolve(this.getDetenteurOnline(id));
                    } else {
                        reject("Détenteur non trouvé");
                    }
                }
            }).catch(err => reject(err));
        });
    }

    static async getDetenteurWithAsync(id) {
        return new Promise((resolve, reject) => {
            this.getList().then( res => {

                if (!_.includes(id, 'N-')) {
                    id = parseInt(id)
                }

                const det = _.find(res, ['id', id]);

                if (det !== undefined) {
                    resolve(det);
                } else {
                    resolve(this.getDetenteurOnline(id));
                    reject(id);
                }

            }).catch(err => reject(err))

        })

    }

    static getList() {
        return new Promise((resolve, reject) => {
            localforage
                .getItem('listDetenteurs')
                .then(detenteurs => {
                    const parsed = JSON.parse(detenteurs);
                    // Un cache peut déjà contenir des doublons : clés v-for en double → crash Vue « reading 'key' »
                    resolve(Array.isArray(parsed) ? _.uniqBy(parsed, 'id') : [])
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

    static stockDetenteursOnLocal(data) {
        return new Promise(async (resolve, reject) => {
            let dets = data.filter(det => det.actif === true);

            let installs = [];

            _.each(dets, det => {

                _.each(det.installations, install => {
                    if (install.actif === true) {
                        install['detenteur'] = det.id;
                        installs.push(install)
                    }
                });

                delete det['installations']

            });

            // Préserver les installations créées hors ligne (IDs N-xxx)
            let existing = JSON.parse(await localforage.getItem('listInstallations')) || [];
            let offlineInstalls = existing.filter(i => String(i.id).startsWith('N-'));
            let mergedInstalls = installs.concat(offlineInstalls);

            // Préserver les détenteurs créés hors ligne (IDs N-xxx) pas encore synchronisés
            let existingDets = JSON.parse(await localforage.getItem('listDetenteurs')) || [];
            let offlineDets = existingDets.filter(d => String(d.id).startsWith('N-'));
            let mergedDets = dets.concat(offlineDets);

            localforage
                .setItem('listInstallations', JSON.stringify(mergedInstalls))
                .then(function () {

                    localforage
                        .setItem('listDetenteurs', JSON.stringify(mergedDets))
                        .then(function () {
                            resolve(true);
                        })
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))
        });
    }

    static addNewDetenteurs(data) {
        return new Promise(async (resolve, reject) => {
            let dets = data.filter(det => det.actif === true);

            let installations = JSON.parse(await localforage.getItem('listInstallations')) || [];
            let detenteurs = JSON.parse(await localforage.getItem('listDetenteurs')) || [];

            // getLastsDetenteurs tourne en parallèle du rafraîchissement complet de la liste :
            // la version reçue remplace celle du cache au lieu de s'y ajouter en double.
            const remplacerOuAjouter = (liste, element) => {
                const index = _.findIndex(liste, ['id', element.id]);
                if (index === -1) {
                    liste.push(element);
                } else {
                    liste[index] = element;
                }
            };

            _.each(dets, det => {
                _.each(det.installations, install => {
                    if (install.actif === true) {
                        install['detenteur'] = det.id;
                        remplacerOuAjouter(installations, install);
                    } else {
                        _.remove(installations, ['id', install.id]);
                    }
                });

                det.raison_sociale = det.raisonSociale;
                det.code_postal = det.codePostal;
                det.code_client = det.codeClient;
                det.complement_adresse = det.complementAdresse;
                delete det.raisonSociale;
                delete det.codePostal;
                delete det.codeClient;
                delete det.complementAdresse;
                delete det.installations;
                remplacerOuAjouter(detenteurs, det);
            });

            // Répare aussi les doublons déjà présents dans le cache lu au départ
            installations = _.uniqBy(installations, 'id');
            detenteurs = _.uniqBy(detenteurs, 'id');

            localforage
                .setItem('listInstallations', JSON.stringify(installations))
                .then(function () {
                    localforage
                        .setItem('listDetenteurs', JSON.stringify(detenteurs))
                        .then(function () {
                            resolve(true);
                        })
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))
        });
    }
}

export default Detenteur



// WEBPACK FOOTER //
// ./src/js/models/Detenteur.js